import { ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { Subscription } from 'rxjs';
import { OptionsRequest } from '../earning/options.interface';
import { FinanceService } from '../../../../modules/finance-tools/services/finance.service';

@Component({
  selector: 'gtd-finance-field',
  templateUrl: './finance-field.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => FinanceFieldComponent),
    },
  ],
})
@DestroySubscribers()
export class FinanceFieldComponent implements ControlValueAccessor, OnInit {
  @Input() public dependValues: {
    affiliate_id: UntypedFormControl;
    affiliate_cluster_id: UntypedFormControl;
  };
  @Input() public action: string;
  @Input() public repository: string;
  @Input() public key: string;
  @Input() public label: string;
  @Input() public control: UntypedFormControl;
  @Input() public conflictValues: UntypedFormControl;
  @Input() public clearable: boolean;
  @Input() public disabled: boolean;

  public subscribers: Record<string, Subscription> = {};

  public onChange: (value: string) => void = () => {};
  public onTouch = () => {};

  public options = {};

  constructor(private financeService: FinanceService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    Object.keys(this.dependValues).forEach((dependKey) => {
      this.subscribers[dependKey] = this.dependValues[dependKey].valueChanges.subscribe((value: string) => {
        this.control?.setValue(null);
        Object.keys(this.dependValues).forEach((otherDependKey) => {
          if (value && otherDependKey !== dependKey && this.dependValues[otherDependKey].value) {
            this.dependValues[otherDependKey].setValue(null);
          }
        });
        if (value) {
          this.subscribers.options?.unsubscribe();
          this.subscribers.options = this.financeService
            .getOptions(this.action, this.repository, dependKey, value)
            .subscribe((data: OptionsRequest) => {
              this.options = data.data.options[this.key].reduce((result, item) => {
                result[item.key] = item.value + ' / ' + item.key;
                return result;
              }, {});
              this.control.updateValueAndValidity();
              this.cd.detectChanges();
            });
        }
      });
    });

    this.subscribers.conflict = this.conflictValues?.valueChanges.subscribe((value) => {
      this.disabled = !!value;
    });
  }

  registerOnChange(fn: (value) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(): void {}
}
